import { Component } from '@angular/core';

import { CustomPageBlockComponent } from './custom-page-block.component';

/**
 * Display a URL button with the specified URL and label.
 * If is_external is true, the link will open in a new tab.
 */
@Component({
  selector: 'app-custom-page-url-button',
  template: `<div class="max-w-screen-lg mx-auto px-8">
    <div class="flex flex-row items-center justify-center">
      <a [href]="data().url" class="primary-button" [attr.target]="data().is_external ? '_blank' : null">
        {{ data().label }}
      </a>
    </div>
  </div>`,
  standalone: true,
})
export class CustomPageUrlButtonComponent extends CustomPageBlockComponent<'url_button'> {}
